import { PaymentList } from './PaymentList'
import { PaymentShow } from './PaymentShow'
import EuroIcon from '@material-ui/icons/Euro'

export const payment = {
  list: PaymentList,
  show: PaymentShow,
  icon: EuroIcon,
}
